<template>
  <div class="panel-body">
    <div class="text-size-20">
      売上アップの可能性がある商品を見つけ、推奨アクションをご提案します。
    </div>
    <div class="fba-longterm-banner">
      <div class="fba-longterm-icon"></div>
      <fieldset>
        <legend>注目!</legend>
        <div class="fba-longterm-content">
          推奨アクションを実施して、売上アップにつなげましょう！
        </div>
      </fieldset>
    </div>
    <div v-if="disablePromotion && !isBasicPlan" class="action-panel" style="max-width: 700px;">
      <div class="action-label">推奨アクション</div>
      <div class="action-title-row">
        <h4 class="action-title">広告運用を開始する</h4>
      </div>
      <div class="flexbox justify-between align-center gap-20">
        <p>広告運用に申し込み、商品の露出と販売機会を広げましょう。</p>
        <button
          class="btn btn-orange"
          @click="$router.push('/promotion/top')"
        >
          広告運用を開始する
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div v-else class="action-panel">
      <premium-modal v-if="isBasicPlan" />
      <div class="action-label">推奨アクション</div>
      <div class="action-title-row">
        <h4 class="action-title">{{ products.length > 0 ? '広告に登録する' : '広告運用を継続する' }}</h4>
        <div class="action-title-right">
          <span v-if="selectedItems.length > 0" class="selected-count">{{ selectedItems.length }}件選択中</span>
          <button
            v-if="!isBasicPlan && !disablePromotion && products.length > 0"
            class="btn btn-orange"
            :disabled="selectedItems.length === 0"
            @click="bulkAddPromotion"
          >選択した商品を広告に登録する</button>
        </div>
      </div>
      <p>
        {{ products.length > 0 ? '広告に登録する商品を選択してください。複数の商品をまとめて登録できます。' : '現在の設定のまま広告運用を継続し、販売機会を広げていきましょう。' }}
      </p>
      <div class="expansion-table" v-if="products.length > 0">
        <table class="full-width bg-white">
          <thead>
            <tr>
              <th class="col-check">
                <input type="checkbox" v-model="isCheckAll" @change="handleSelectAll">
              </th>
              <th class="col-info">商品情報</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in products" :key="item.asin">
              <td class="col-check">
                <input type="checkbox" v-model="selectedItems" :value="item.asin">
              </td>
              <td class="col-info">
                <div class="flexbox gap-10 no-wrap">
                  <img :src="item.image" class="product-img" alt="">
                  <div>
                    <div class="tooltip-wrapper">
                      <a
                        :href="'https://www.amazon.co.jp/gp/offer-listing/' + item.asin"
                        target="_blank"
                        class="text--underline product-name"
                      >{{ sliceProductName(item.productName) }}</a>
                      <span class="tooltip-text">{{ item.productName }}</span>
                    </div>
                    <div class="flexbox gap-20">
                      <div><span class="font-bold">SKU：</span>{{ item.sku }}</div>
                      <div><span class="font-bold">ASIN：</span>{{ item.asin }}</div>
                      <div><span class="font-bold">FNSKU：</span>{{ item.fnsku }}</div>
                    </div>
                    <div class="flexbox gap-20">
                      <span>Amazon価格：<b>¥{{ formatNumber(item.amazonPrice) }}</b></span>
                      <span>在庫数：<b>{{ item.quantity }}</b></span>
                      <span>Amazon受取金額：<b>¥{{ formatNumber(item.offerPrice) }}</b></span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/common/utility'
import PremiumModal from './components/PremiumModalOverlay'
import SalemonAgentService from '@/services/salemonagentservice'
import PromotionService from '@/services/promotionservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      isCheckAll: false,
      selectedItems: [],
      products: [],
      loader: null
    }
  },

  components: {
    PremiumModal
  },

  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    },
    disablePromotion () {
      return this.$store.getters.getUser.promotionFlg === '0'
    }
  },

  created () {
    this.getProductAvailable()
  },

  methods: {
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    sliceProductName (productName) {
      const length = 80
      if (productName.length <= length) return productName
      return productName.slice(0, length / 2) + ' ... ' + productName.slice(-(length / 2))
    },
    handleSelectAll () {
      this.selectedItems = this.isCheckAll ? this.products.map(i => i.asin) : []
    },
    async getProductAvailable () {
      this.loader = this.$loading.show()
      await SalemonAgentService.getSalesExpansionProducts()
        .then((response) => {
          this.products = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async bulkAddPromotion () {
      if (this.isBasicPlan || this.disablePromotion) return

      this.loader = this.$loading.show()

      const payload = {
        asins: this.selectedItems
      }

      let logParams = {
        name: eventCode.salemon_agent.sale_expansion.click_register_btn,
        properties: payload
      }
      EventService.postTrackLog(logParams)

      await PromotionService.addPromotionProducts(payload)
        .then(response => {
          this.products = this.products.filter(i => !this.selectedItems.includes(i.asin))
          this.selectedItems = []
          this.isCheckAll = false
          this.loader && this.loader.hide()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },

  watch: {
    selectedItems () {
      this.isCheckAll = this.products.length > 0 && this.selectedItems.length === this.products.length
    }
  },

  mounted () {
    let logParams = {
      name: eventCode.salemon_agent.sale_expansion.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>

<style scoped>
.panel-body::before {
  display: unset;
  content: unset;
}
.panel-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.no-wrap {
  flex-wrap: nowrap;
}
.fba-longterm-banner {
  display: flex;
  flex-wrap: nowrap;
  justify-content: left;
  gap: 10px;
  font-size: 20px;
  width: 100%;
  color: #008cc6;
  font-weight: bold;
}
.fba-longterm-icon {
  animation: fuwafuwa 3s ease-in-out infinite alternate;
  background: url(https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png) no-repeat center center / 90px auto;
  display: inline-block;
  transition: 1.5s ease-in-out;
  width: 100px;
  height: 100px;
}
fieldset {
  border: 3px solid #008cc6;
  border-radius: 12px;
  padding: 10px 20px;
  background: #fff;
  display: inline-block;
  position: relative;
}
legend {
  color: #008cc6;
  font-weight: bold;
  border-bottom: unset;
  margin-bottom: unset;
  width: unset;
  padding: 0 10px;
}
.fba-longterm-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.action-panel {
  background: #fff;
  border: 1px solid #dde1eb;
  border-radius: 4px;
  padding: 16px;
  border-left: 4px solid #008cc6;
}
.action-panel:has(.premium-overlay) {
  position: relative;
  overflow: hidden;
}
.action-label {
  color: #008cc6;
  margin-bottom: 4px;
}
.action-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 6px;
}
.action-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}
.action-title-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.selected-count {
  font-size: 14px;
  color: #008cc6;
  font-weight: bold;
}
.expansion-table {
  max-height: 450px;
  overflow-y: auto;
}
.expansion-table table {
  width: 100%;
  border-collapse: collapse;
}
.expansion-table tr {
  border: 1px solid #d9d9d9;
}
.expansion-table td,
.expansion-table th {
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
}
.expansion-table th {
  background-color: #deebf7;
  color: #666;
  position: sticky;
  top: -1px;
  z-index: 1;
}
.col-check {
  width: 40px;
  text-align: center;
}
.col-info {
  width: 100%;
}
.expansion-table td.col-info {
  vertical-align: top;
}
.product-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  flex-shrink: 0;
}
.product-name {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  max-width: 700px;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
  max-width: 100%;
}
.tooltip-text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 110%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: normal;
  width: 400px;
}
.tooltip-text::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555 transparent;
}
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.btn-orange {
  background-color: #e8830a;
  color: #fff;
}
@keyframes fuwafuwa {
  0% { transform: translate(0, 0) rotate(-7deg); }
  50% { transform: translate(0, -7px) rotate(0deg); }
  100% { transform: translate(0, 0) rotate(7deg); }
}
@media (max-width: 425px) {
  .text-size-20 { font-size: 14px; }
  .fba-longterm-icon { display: none; }
  .fba-longterm-content { font-size: 14px; }
}
</style>



// WEBPACK FOOTER //
// src/view/salemonAgent/SalesExpansion.vue